import { handleBoAuthExpiry } from './boAuthExpiryHandler';

class ApiService {
    constructor() {}

    async fetchWithHeaders(url, method = 'GET', options = {}) {
        const headers = {
            'Content-Type': 'application/json',
            ...options.headers,
        };

        const response = await fetch(url, {
            method,
            credentials: 'same-origin',
            headers,
            ...options,
        });

        let jsonResponse;
        try {
            jsonResponse = await response.json();
        } catch (error) {
            jsonResponse = {};
        }

        if (!response.ok) {
            const error = new Error(`HTTP ${response.status}`);

            error.response = jsonResponse;
            error.status = response.status;

            if (handleBoAuthExpiry(error, url)) {
                // Redirect to login in flight: never resolve so nothing surfaces while the page unloads.
                return new Promise(() => {});
            }
            throw error;
        }

        return jsonResponse;
    }

    /**
     * Same session and error handling as fetchWithHeaders, but hands back the raw
     * body. Used by downloads, whose payload is not JSON.
     */
    async fetchBlob(url, method = 'GET', options = {}) {
        const response = await fetch(url, {
            method,
            credentials: 'same-origin',
            ...options,
        });

        if (!response.ok) {
            const error = new Error(`HTTP ${response.status}`);

            error.status = response.status;

            if (handleBoAuthExpiry(error, url)) {
                // Redirect to login in flight: never resolve so nothing surfaces while the page unloads.
                return new Promise(() => {});
            }
            throw error;
        }

        return response.blob();
    }
}

export default ApiService;
